<template>
  <a-modal
      v-model:visible="visible"
      title="生成工单"
      :on-before-ok="handleOk"
      @cancel="handleCancel"
      width="800px"
      :mask-closable="false"
      :ok-loading="loading"
      ok-text="生成工单"
      draggable
  >
    <div class="create-work-order-content">
      <!-- 服务单信息展示 -->
      <a-alert 
        type="info" 
        style="margin-bottom: 20px;"
        :show-icon="true"
        v-if="serviceOrder"
      >
        <template #title>
          基于项目服务单生成工单
        </template>
        <div>
          <p><strong>项目任务单ID：</strong>{{ serviceOrder.projectTaskId }}</p>
          <p><strong>客户编码：</strong>{{ serviceOrder.customerCode }}</p>
          <p><strong>门店编码：</strong>{{ serviceOrder.storeCode }}</p>
          <p><strong>服务内容：</strong>{{ serviceOrder.serviceContent }}</p>
        </div>
      </a-alert>

      <a-form ref="formRef" :model="formData" :rules="rules" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="任务单号" field="projectTaskId">
              <a-input-number 
                v-model="formData.projectTaskId" 
                placeholder="自动带入任务单号" 
                :min="1"
                :precision="0"
                style="width: 100%"
                readonly
                hide-button
                disabled
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="工单标题" field="workOrderTitle">
              <a-input v-model="formData.workOrderTitle" placeholder="请输入工单标题" allow-clear />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="工单类型" field="workorderType">
              <a-select v-model="formData.workorderType" placeholder="请选择工单类型" allow-clear>
                <a-option value="常规">常规</a-option>
                <a-option value="应急">应急</a-option>
                <a-option value="检查">检查</a-option>
                <a-option value="首次">首次</a-option>
                <a-option value="临时">临时</a-option>
                <a-option value="勘察">勘察</a-option>
                <a-option value="专项">专项</a-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="是否协同" field="urgent">
              <a-switch v-model="formData.urgent" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="服务人员" field="serviceStaff">
              <a-input v-model="formData.serviceStaff" placeholder="请输入服务人员" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开始时间" field="serviceTime">
              <a-date-picker 
                v-model="formData.serviceTime"
                style="width: 100%" 
                show-time
                placeholder="请选择开始时间"
                format="YYYY-MM-DD HH:mm"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="工时(小时)" field="estimatedDuration">
              <a-input-number 
                v-model="formData.estimatedDuration" 
                placeholder="请输入预计工时" 
                :min="0"
                :precision="1"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="费用(元)" field="estimatedCost">
              <a-input-number 
                v-model="formData.estimatedCost" 
                placeholder="请输入预计费用" 
                :min="0"
                :precision="2"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item label="工作地点" field="contactPhone">
          <a-input v-model="formData.workLocation" placeholder="请输入工作地点" allow-clear />
        </a-form-item>
        
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="联系人" field="contactPerson">
              <a-input v-model="formData.contactPerson" placeholder="请输入联系人" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="联系电话" field="contactPhone">
              <a-input v-model="formData.contactPhone" placeholder="请输入联系电话" allow-clear />
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item label="工单备注" field="workOrderRemark">
          <a-textarea 
            v-model="formData.workOrderRemark"
            placeholder="请输入工单备注"
            :rows="3"
            allow-clear 
          />
        </a-form-item>

        <!-- 自定义属性 -->
<!--        <a-divider>自定义属性</a-divider>-->
<!--        <div v-if="customAttributes.length > 0">-->
<!--          <div v-for="(attr, index) in customAttributes" :key="index" class="custom-attribute-item">-->
<!--            <a-row :gutter="16">-->
<!--              <a-col :span="8">-->
<!--                <a-form-item :label="`属性名 ${index + 1}`">-->
<!--                  <a-input -->
<!--                    v-model="attr.key" -->
<!--                    placeholder="请输入属性名"-->
<!--                    allow-clear -->
<!--                  />-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :span="8">-->
<!--                <a-form-item :label="`属性值 ${index + 1}`">-->
<!--                  <a-input -->
<!--                    v-model="attr.value" -->
<!--                    placeholder="请输入属性值"-->
<!--                    allow-clear -->
<!--                  />-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :span="6">-->
<!--                <a-form-item :label="`属性类型 ${index + 1}`">-->
<!--                  <a-select v-model="attr.type" placeholder="请选择类型">-->
<!--                    <a-option value="text">文本</a-option>-->
<!--                    <a-option value="number">数字</a-option>-->
<!--                    <a-option value="date">日期</a-option>-->
<!--                    <a-option value="boolean">布尔值</a-option>-->
<!--                  </a-select>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :span="2" style="display: flex; align-items: end;">-->
<!--                <a-button type="outline" status="danger" @click="removeCustomAttribute(index)" style="margin-bottom: 8px;">-->
<!--                  删除-->
<!--                </a-button>-->
<!--              </a-col>-->
<!--            </a-row>-->
<!--          </div>-->
<!--        </div>-->
<!--        <a-button type="dashed" @click="addCustomAttribute" style="width: 100%; margin-top: 10px;">-->
<!--          + 添加自定义属性-->
<!--        </a-button>-->
      </a-form>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, watch, computed } from 'vue'
import { Message } from '@arco-design/web-vue'
import { createWorkOrderFromServiceOrder } from '@/apis/work-order-api'
import {dateTimeString2timestampNumber} from "@/utils/date-util";

// 定义 props
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  serviceOrder: {
    type: Object,
    default: () => ({})
  }
})

// 定义 emits
const emit = defineEmits(['update:modelValue', 'success'])

// 响应式数据
const visible = ref(false)
const loading = ref(false)
const formRef = ref()
const customAttributes = ref([])

// 表单数据
const formData = ref({
  projectTaskId: null,
  projectServiceOrderId: null,
  workOrderTitle: '',
  workorderType: '',
  urgent: false,
  serviceStaff: '',
  serviceTime: '',
  estimatedDuration: null,
  estimatedCost: null,
  workLocation: '',
  contactPerson: '',
  contactPhone: '',
  workOrderRemark: '',
  extensionFields: {}
})

// 表单验证规则
const rules = ref({
  projectTaskId: [
    { required: true, message: '任务单号不能为空' }
  ],
  workOrderTitle: [
    { required: true, message: '请输入工单标题' },
    { min: 2, max: 100, message: '工单标题长度为2-100个字符' }
  ],
  workorderType: [
    { required: true, message: '请选择工单类型' }
  ],
  serviceStaff: [
    { required: true, message: '请输入服务人员' }
  ],
  serviceTime: [
    { required: true, message: '请选择开始时间' }
  ],
  estimatedDuration: [
    { required: true, message: '请输入预计工时' }
  ],
  estimatedCost: [
    { required: true, message: '请输入预计费用' }
  ],
  contactPhone: [
    {
      match: /^1[3-9]\d{9}$/, 
      message: '请输入正确的手机号码' 
    }
  ]
})

// 监听 modelValue 变化
watch(() => props.modelValue, (newVal) => {
  visible.value = newVal
  if (newVal && props.serviceOrder) {
    initFormData()
  }
})

// 监听 visible 变化
watch(visible, (newVal) => {
  emit('update:modelValue', newVal)
})

// 初始化表单数据
const initFormData = () => {
  if (!props.serviceOrder) return
  
  formData.value = {
    projectTaskId: props.serviceOrder.projectTaskId,
    projectServiceOrderId: props.serviceOrder.id,
    workOrderTitle: `${props.serviceOrder.serviceType || ''}服务单-${props.serviceOrder.customerCode || ''}`,
    workorderType: '常规',
    urgent: props.serviceOrder.isOvertime === 1,
    serviceStaff: props.serviceOrder.serviceStaffCode || '',
    serviceTime: '',
    estimatedDuration: props.serviceOrder.unitServiceHours || null,
    estimatedCost: props.serviceOrder.unitPrice || null,
    workLocation: '',
    contactPerson: '',
    contactPhone: '',
    workOrderRemark: props.serviceOrder.remark || '',
    extensionFields: {}
  }
  
  // 清空自定义属性
  customAttributes.value = []
}

// 添加自定义属性
const addCustomAttribute = () => {
  customAttributes.value.push({
    key: '',
    value: '',
    type: 'text'
  })
}

// 删除自定义属性
const removeCustomAttribute = (index) => {
  customAttributes.value.splice(index, 1)
}

// 生成扩展字段JSON
const generateExtensionFields = () => {
  const extensionFields = {}
  
  customAttributes.value.forEach(attr => {
    if (attr.key && attr.value) {
      let value = attr.value
      
      // 根据类型转换值
      switch (attr.type) {
        case 'number':
          value = parseFloat(attr.value) || 0
          break
        case 'boolean':
          value = attr.value === 'true' || attr.value === '1'
          break
        case 'date':
          value = attr.value
          break
        default:
          value = attr.value
      }
      
      extensionFields[attr.key] = value
    }
  })
  
  return extensionFields
}

// 处理确认按钮
const handleOk = async (done) => {
  try {
    // 验证表单
    const validateResult = await formRef.value?.validate()
    
    // 如果验证失败，阻止提交和关闭弹框
    if (validateResult !== undefined) {
      done(false)
      return false
    }
    
    loading.value = true
    
    // 时间处理
    formData.value.serviceTime = dateTimeString2timestampNumber(formData.value.serviceTime)
    
    // 准备提交数据
    const submitData = { 
      ...formData.value,
      extensionFields: generateExtensionFields()
    }
    
    // 转换时间格式（工时从小时转换为分钟）
    if (submitData.estimatedDuration) {
      submitData.estimatedDuration = Math.round(submitData.estimatedDuration * 60)
    }
    
    let response = await createWorkOrderFromServiceOrder(submitData)
    
    if (response.code === 0) {
      Message.success('工单生成成功')
      emit('success', response.data)
      visible.value = false
      done(true)
      return true
    } else {
      Message.error(response.message || '工单生成失败')
      done(false)
    }
  } catch (error) {
    // 如果是表单验证错误，不显示网络错误提示
    if (error && typeof error === 'object' && error.name !== 'ValidateError') {
      Message.error('工单生成失败')
      console.error('操作失败:', error)
    }
    done(false)
    return false
  } finally {
    loading.value = false
  }
}

// 处理取消按钮
const handleCancel = () => {
  formRef.value?.clearValidate()
  visible.value = false
  customAttributes.value = []
}
</script>

<style scoped>
.create-work-order-content {
  padding: 10px 0;
}

.a-form-item {
  margin-bottom: 16px;
}

.custom-attribute-item {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #f9fafb;
}
</style>